import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQuery } from "@/redux/baseQuery";

export interface GetSumsubTokenResponse {
  token: string;
  userId: string;
}

export interface GetSumsubTokenRequest {
  role: "Owner" | "Driver";
}

export interface GetKycCountryResponse {
  /** ISO alpha-2, or null when Sumsub has no applicant, no country, or one we cannot map. */
  country: string | null;
}

export const kycApi = createApi({
  reducerPath: "kycApi",
  baseQuery,
  endpoints: (builder) => ({
    getSumsubToken: builder.mutation<GetSumsubTokenResponse, GetSumsubTokenRequest>({
      query: (body) => ({
        url: "/v1/kyc/tokens",
        method: "POST",
        body,
      }),
    }),
    /**
     * The country KYC established, resolved from Sumsub on demand.
     *
     * The applicantReviewed webhook writes it to account metadata and the profile carries it, but
     * approval is asynchronous — a client reaching platform setup first sees nothing there. This
     * asks Sumsub directly rather than polling for a value a rejected review would never produce.
     */
    getKycCountry: builder.query<GetKycCountryResponse, void>({
      query: () => "/v1/kyc/country",
    }),
  }),
});

export const { useGetSumsubTokenMutation, useGetKycCountryQuery } = kycApi;
